var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: \"Nunito\";\n  src: url(" + escape(require("@/assets/fonts/Nunito/Nunito-VariableFont_wght.ttf")) + ");\n}\n\n@font-face {\n  font-family: \"IbmPlex\";\n  src: url(" + escape(require("@/assets/fonts/IBM_Plex_Serif/IBMPlexSerif-Regular.ttf")) + ");\n\n  font-weight: 100 900;\n  font-style: normal;\n}\n", ""]);

// exports
